/** Plain text for chat tags / timeline (no HTML from B1 vision fields). */
export function chatDisplayText(raw: string | null | undefined, maxLen = 120): string {
  if (!raw) return '';
  let t = String(raw)
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\s+/g, ' ')
    .trim();
  if (t.length > maxLen) t = `${t.slice(0, maxLen - 1)}…`;
  return t;
}
